// extracted by mini-css-extract-plugin
export default {"main":"Breadcrumbs_main__6j4LN","breadlist":"Breadcrumbs_breadlist__m+8uR","breadcrumb":"Breadcrumbs_breadcrumb__5KvgO","breadcrumbActive":"Breadcrumbs_breadcrumbActive__1RVly"};